var $mpkbPage,
    $categoriesContainer,
    $categoriesSuperContainer,
    $mainCategoriesPanel,
    $subCategoriesPanel,
    $showSubCategoryListItems,
    $subCategoryListItems,
    $loadCategoryArticleListItems,
    $hideSubcategoriesBtn,
    $resultsList,
    $resultsLoading,
    $resultsContainer,
    $searchInput,
    searchInputDebounceTimer,
    $clearSearchBtn,
    $resultsText,
    $loadingText,
    $noresultsText,
    arrowHtml,
    headerHeight,
    urlMainCat,
    urlSubCat
;

$(document).ready(function($) {

  $mpkbPage = $("#js-mpkb-page");

  if($mpkbPage.length) {
    loadMkbpPage();
  }

});

function loadMkbpPage() {

  $categoriesContainer = $("#js-categories-container");
  $categoriesSuperContainer = $("#js-categories-supercontainer");
  $mainCategoriesPanel = $("#js-categories-panel-main");
  $subCategoriesPanel = $("#js-categories-panel-sub");
  $resultsContainer = $("#js-results-container");
  $resultsLoading = $("#js-results-loading");
  $resultsList = $("#js-results");
  $searchInput = $("#js-search-input");
  $clearSearchBtn = $("#js-clear-search");
  $resultsText = $("#js-results-text");
  $loadingText = $("#js-loading-text");
  $noresultsText = $("#js-noresults-text");
  headerHeight = $('header').height();

  $subCategoryListItems = $subCategoriesPanel.find('.js-subcategory');

  $showSubCategoryListItems = $categoriesContainer.find('.js-category-showsubcats');
  $loadCategoryArticleListItems = $categoriesContainer.find('.js-category-loadarticles');

  $hideSubcategoriesBtn = $("#js-hide-subcategories");

  preloadFromURL();

  $showSubCategoryListItems.click(function() {
    var $thisItem = $(this);
    var mainCatId = $thisItem.data('category');
    urlMainCat = mainCatId;
    urlSubCat = false;
    updateUrl();

    $resultsContainer.removeClass('js-loaded');

    $thisItem.addClass('is-open').siblings().removeClass('is-open');

    $subCategoryListItems.each(function(i, elem) {
      $(elem).removeClass('is-open');
      var shouldShow = $(elem).data('parent') === mainCatId;
      $(elem).toggleClass('is-hidden', !shouldShow);
    });

    $categoriesContainer.addClass('js-show-subcategories');

  });

  $searchInput.on('keyup', function(event){
    if (event.key === "Enter") {
      // Scroll into view
      var rcTop = $resultsContainer.offset().top;
      $('html, body').animate({
        scrollTop: rcTop - headerHeight
      }, 500);
    }
  });

  $hideSubcategoriesBtn.click(function() {
    $showSubCategoryListItems.removeClass('is-open');
    $loadCategoryArticleListItems.removeClass('is-open');
    $categoriesContainer.removeClass('js-show-subcategories');
    $resultsContainer.removeClass('js-loaded');
  });

  $loadCategoryArticleListItems.click(function() {
    var $thisItem = $(this);
    var catId = $thisItem.data('category');
    var isMainCat = $thisItem.hasClass('js-maincategory');

    if(isMainCat) {
      $categoriesContainer.removeClass('js-show-subcategories');
      $subCategoryListItems.addClass('is-hidden');
      urlSubCat = false;
      urlMainCat = catId;
    } else {
      urlSubCat = catId;
    }

    updateUrl();

    $thisItem.addClass('is-open').siblings().removeClass('is-open');

    getAndDisplayCategoryArticles(catId);
  });

  $searchInput.on('keyup', function(e) {
    if ($searchInput.val().length < 3) {
      return;
    }

    if(searchInputDebounceTimer) {
      window.clearTimeout(searchInputDebounceTimer);
    }
    searchInputDebounceTimer = window.setTimeout(function() {
      doSearch();
    }, 250);

  });

  $clearSearchBtn.click(function(){
    $searchInput.val('');
    $resultsContainer.removeClass('js-loaded');
    $categoriesSuperContainer.removeClass('js-hide');
    $clearSearchBtn.removeClass('js-show');
  });


  //hash
  var hashString = location.hash.substr(1);
  if(hashString) {
    var hashSearchQuery = decodeURI(hashString.substr(hashString.search(/(?:^|&)s=/))
      .split('&')[0]
      .split('=')[1]);
    console.log(hashSearchQuery);
    if (hashSearchQuery) {
      $searchInput.val(hashSearchQuery);
      doSearch();
    }
  }

  $(window).on('resize', function() {
    headerHeight = $('header').height();
  });

}

function updateUrl() {
  var getUrl = window.location;
  var baseUrl = getUrl .protocol + "//" + getUrl.host + "/" + getUrl.pathname.split('/')[1];

  if (urlMainCat) {
    baseUrl = baseUrl + '?main=' + urlMainCat;
  }

  if (urlSubCat) {
    baseUrl = baseUrl + '&sub=' + urlSubCat;
  }

  history.pushState(null, null, baseUrl);
}

var getUrlParameter = function getUrlParameter(sParam) {
  var sPageURL = window.location.search.substring(1),
    sURLVariables = sPageURL.split('&'),
    sParameterName,
    i;

  for (i = 0; i < sURLVariables.length; i++) {
    sParameterName = sURLVariables[i].split('=');

    if (sParameterName[0] === sParam) {
      return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
    }
  }
};

function preloadFromURL() {
  var mainCat = getUrlParameter('main');
  var activeMainCat = $('.js-maincategory.js-category-loadarticles.is-open').data('category');
  if (activeMainCat) {
    getAndDisplayCategoryArticles(mainCat);
    return;
  }

  var subCat  = getUrlParameter('sub');
  if (subCat) {
    getAndDisplayCategoryArticles(subCat);
  }
}


function doSearch() {
    var searchValue = $searchInput.val();
    if(searchValue === '') {
      $clearSearchBtn.removeClass('js-show');
      $resultsContainer.removeClass('js-loaded');
      $categoriesSuperContainer.removeClass('js-hide');
    } else {
      $clearSearchBtn.addClass('js-show');
      $categoriesSuperContainer.addClass('js-hide');
      getAndDisplaySearchArticles($searchInput.val())
    }
}

function getAndDisplaySearchArticles(searchQuery) {
  $resultsContainer.removeClass('js-loaded').addClass('js-loading');
  ajax('mpkb-get-articles', {
    search: searchQuery
  }, function(response) {
    displayResults(response.articles)
  }, function(error) {
    console.error(error);
  });
}

function getAndDisplayCategoryArticles(categoryId) {
  $resultsContainer.removeClass('js-loaded').addClass('js-loading');
  ajax('mpkb-get-articles', {
    category: categoryId
  }, function(response) {
    displayResults(response.articles)
  }, function(error) {
    console.error(error);
  });
}

function displayResults(articles) {

  if(articles === null || articles.length === 0) {
    $resultsContainer.removeClass('js-loading').addClass('js-loaded js-noresults');
    $resultsList.html('');
  }  else {
    var html = '';
    $.each(articles, function (i, article) {
      html += '<a class="c-link-list__item" href="' + article.link + '" title="' + article.title + '">' + article.title + arrowHtml + '</a>';
    });
    $resultsList.html(html);
    $resultsContainer.removeClass('js-loading js-noresults').addClass('js-loaded');
  }

  // Scroll into view
  // var rcTop = $resultsContainer.offset().top;
  // $('html, body').animate({
  //   scrollTop: rcTop - headerHeight
  // }, 500);
}



function ajax(action, postData, succesCallback, errorCallback, dataType) {

  postData = jQuery.extend(postData, {action: action});

  if (typeof dataType === 'undefined') dataType = 'json';

  jQuery.ajax({
    type: "POST",
    url: linku_ajax_url,
    data: postData,
    dataType: dataType,
    success: function (response) {
      if (response === '0') {
        if (typeof errorCallback === 'function') errorCallback(response);
      }
      else {
        if (typeof succesCallback === 'function') succesCallback(response);
      }
    },
    error: function (response) {
      if (typeof errorCallback === 'function') {
        try {
          if (typeof response.responseJSON === 'object') {
            errorCallback(response.responseJSON);
          }
          else if (typeof response.responseText === 'string' && response.responseText !== '') {
            errorCallback(JSON.parse(response.responseText));
          }
          else {
            errorCallback({'message': 'general'});
          }
        }
        catch(e){
          errorCallback({'message': 'general', error: e});
        }
      }
    }
  });

}

arrowHtml = '<div class="c-link-list__arrow">' +
  '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 50 50" style="enable-background:new 0 0 50 50;" xml:space="preserve">' +
  '<g>' +
  '<path d="M30.77,25c0,0.2-0.07,0.4-0.22,0.56l-9.88,10.77c-0.31,0.34-0.83,0.36-1.17,0.05c-0.34-0.31-0.36-0.84-0.05-1.17L28.81,25' +
  ' l-9.36-10.21c-0.31-0.34-0.29-0.86,0.05-1.17c0.34-0.31,0.86-0.29,1.17,0.05l9.88,10.77C30.7,24.6,30.77,24.8,30.77,25z"></path>' +
  '</g>' +
  '</svg>' +
  '</div>';
